import {useEffect, useRef} from "react";

const DEFAULT_THROTTLE_MS = 5 * 60 * 1000;

/** Call `onRefresh` on user activity, throttled (sliding session extension). */
export function useActivityRefresh(onRefresh: () => void, enabled: boolean, throttleMs = DEFAULT_THROTTLE_MS) {
  const last = useRef(0);
  const cb = useRef(onRefresh);
  cb.current = onRefresh;
  useEffect(() => {
    if(!enabled) return;
    const bump = () => {
      const now = Date.now();
      if(now - last.current < throttleMs) return;
      last.current = now;
      cb.current();
    };
    const onVis = () => {
      if(document.visibilityState === "visible") bump();
    };
    const events: (keyof WindowEventMap)[] = ["click", "keydown", "scroll", "mousemove"];
    events.forEach((e) => window.addEventListener(e, bump, {passive: true}));
    document.addEventListener("visibilitychange", onVis);
    return () => {
      events.forEach((e) => window.removeEventListener(e, bump));
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [enabled, throttleMs]);
}
